export default __webpack_public_path__ + "static/media/icon-plus-horaire.4f20d79c.svg";